(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('InvoicesDataService', InvoicesDataService);
    
    InvoicesDataService.$inject = ['$http', '$q', 'ReportXlsService'];

    function InvoicesDataService($http, $q, ReportXlsService) {

        var service = {
            executeInvoicesData: executeInvoicesData,
            generateInvoicesDataXls: generateInvoicesDataXls,
        };
        var requestUrl = 'api/full-stats';
        return service;

        function executeInvoicesData(obj) {
            return $http.post(requestUrl + '/execute-invoices-data', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
        
        function generateInvoicesDataXls(obj) {
            ReportXlsService.generateExcelFile(obj, requestUrl + '/generate-invoices-data-xls-report', 'statistics_');
        }

    }
})();
